// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"b462b88b","453":"d9636cfa"}[chunkId] + ".chunk.js";
};